import { supabase } from '../lib/supabase'
import { borrarInformesStorage } from '../lib/storage'

function parseJsonArr(val: any): any[] {
  if (Array.isArray(val)) return val
  if (typeof val === 'string' && val) { try { return JSON.parse(val) } catch { return [] } }
  return []
}

// Mapa: tabla Supabase → clave tipo_prueba en la tabla noms
export const TABLE_TO_TIPO: Record<string, string> = {
  'prueba_3801':    'A_3801',
  'prueba_109':     'A_109',
  'prueba_7211':    'A_7211',
  'prueba_134':     'A_134',
  'prueba_7_2_11':  '7_2_11',
  'prueba_7_2_12':  '7_2_12',
  'prueba_7_2_19':  '7_2_19',
  'prueba_275':     'A_275',
  'prueba_172':     'A_172',
  'prueba_9073':    'A_9073',
  'prueba_4920':    'A_4920',
  'prueba_12945':   'A_12945',
  'prueba_083':     'A_083',
  'prueba_073':     'A_073',
  'prueba_105':     'A_105',
  'prueba_104':     'A_104',
  'prueba_5077':    'A_5077',
  'prueba_analisis':'ANALISIS',
  'prueba_105d01':  'A_105D01',
  'prueba_105b02':  'A_105B02',
  'prueba_059_1':   'A_059_1',
  'prueba_059_2':   'A_059_2',
  'prueba_aatcc127':'AATCC127',
  'prueba_s051':    'S051',
  'prueba_221':     'A_221',
  'prueba_225':     'A_225',
  'prueba_228':     'A_228',
  'prueba_229':     'A_229',
  'prueba_230':     'A_230',
  'prueba_adicional': 'A_ADICIONAL',
}

// Mapa: nombre de prueba → tabla de Supabase
export const PRUEBA_TABLE_MAP: Record<string, string> = {
  'NMX-A-3801-INNTEX-2012 PESO DE LA TELA (METODO 5)': 'prueba_3801',
  'NMX-A-109-INNTEX-2012 RESISTENCIA AL RASGADO': 'prueba_109',
  'NMX-A-7211/2-INNTEX-2015 DENSIDAD DE TEJIDO PLANO (METODO A)': 'prueba_7211',
  'NMX-A-134-INNTEX-2013 DENSIDAD DE TEJIDO DE PUNTO': 'prueba_134',
  'TIPO DE TEJIDO MET-7.2-11': 'prueba_7_2_11',
  'TIPO DE LIGAMENTO MET-7.2-12': 'prueba_7_2_12',
  'NMX-A-275/5-INNTEX-2000 DENSIDAD LINEAL DE HILOS EXTRAIDOS DE LA TELA (METODO A)': 'prueba_275',
  'NMX-A-172-INNTEX-2012 RESISTENCIA A LA ABRASIÓN PLANA TABER': 'prueba_172',
  'NMX-A-9073/1-INNTEX-2018 MASA DE NO TEJIDOS': 'prueba_9073',
  'NMX-A-4920-INNTEX-2017 RESISTENCIA AL HUMEDECIMIENTO SUPERFICIAL (MÉTODO DE ROCÍO)': 'prueba_4920',
  'NMX-A-12945-3-INNTEX-2020 DETERMINACIÓN DE FRISAS, VELLOSIDAD Y EMARAÑAMIENTO': 'prueba_12945',
  'NMX-A-083-INNTEX-2020 EVALUACIÓN DE CONFECCIÓN Y DIMENSIÓN DE PRENDAS': 'prueba_083',
  'NMX-A-229-1982 Determinación del pH y Δ pH de un extracto acuoso de cuero': 'prueba_229',
  'NMX-A-221-1982 Determinación de las grasas y otros materiales solubles por extracción con cloruro de metileno': 'prueba_221',
  'NMX-A-225-1982 Determinación de humedad en cuero': 'prueba_225',
  'NMX-A-228-1982 Determinación de cenizas totales y cenizas insolubles en agua': 'prueba_228',
  'NMX-A-230-1982 Determinación del contenido de cromo': 'prueba_230',
  'NMX-A-073-INNTEX-2005 SOLIDEZ DEL COLOR AL FROTE': 'prueba_073',
  'NMX-A-105-C06-INNTEX-2015 SOLIDEZ DEL COLOR AL LAVADO DOMESTICO E INDUSTRIAL': 'prueba_105',
  'NMX-A-105-E04-INNTEX-2019 SOLIDEZ DEL COLOR AL SUDOR': 'prueba_104',
  'TIPO DE ACABADO MET-7.2-19': 'prueba_7_2_19',
  'NMX-A-5077-INNTEX-2015 / NMX-A-6330-INNTEX-2015 CAMBIOS DIMENSIONALES': 'prueba_5077',
  'ANÁLISIS QUÍMICO CUALITATIVO Y CUANTITATIVO': 'prueba_analisis',
  'NMX-A-105-D01-INNTEX-2020 SOLIDEZ DEL COLOR AL LAVADO EN SECO': 'prueba_105d01',
  'NMX-A-105-B02-INNTEX-2019 DETERMINACIÓN DE LA SOLIDEZ DEL COLOR A LA LUZ ARTIFICIAL: ENSAYO DE LA LÁMPARA DE DECOLORACIÓN DE ARCO DE XENÓN': 'prueba_105b02',
  'NMX-A-059/1-INNTEX-2019 DETERMINACIÓN DE LA FUERZA MÁXIMA Y DEL ALARGAMIENTO A LA FUERZA MÁXIMA POR EL MÉTODO DE LA TIRA': 'prueba_059_1',
  'Propiedades de los tejidos frente a la tracción-Parte 2: Determinación de la fuerza máxima por el método de agarre-Método Grab. NMX-059/2-INNTEX-2019': 'prueba_059_2',
  'AATCC TM127-2017(2018) TEST METHOD FOR WATER RESISTANCE: HYDROSTATIC PRESSURE': 'prueba_aatcc127',
  'NMX-S-051-1989 Numeral 7.1.1 Resistencia a la flexión': 'prueba_s051',
  'PRUEBA ADICIONAL': 'prueba_adicional',
}

/**
 * Finds the table for a given prueba name using substring matching.
 */
function getTable(prueba: string): string {
  // Exact match first
  if (PRUEBA_TABLE_MAP[prueba]) return PRUEBA_TABLE_MAP[prueba]
  // Substring match
  for (const [key, table] of Object.entries(PRUEBA_TABLE_MAP)) {
    if (prueba.includes(key) || key.includes(prueba)) return table
  }
  // Partial key match
  for (const [key, table] of Object.entries(PRUEBA_TABLE_MAP)) {
    const shortKey = key.split(' ')[0]
    if (prueba.includes(shortKey)) return table
  }
  throw new Error(`No se encontró tabla para la prueba: ${prueba}`)
}

/**
 * Convert form fields → Supabase column names for each prueba.
 */
export function formDataToSupabase(prueba: string, formData: any, pedidoId: string): Record<string, any> {
  const base: Record<string, any> = { pedido_id: pedidoId }

  if (prueba.includes('NMX-A-3801-INNTEX-2012')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.grados,
      hr: formData.hr,
      numero_solicitud: formData.numero_solicitud,
      termo: formData.id_termohigrometro || '',
      no1_1: formData.no1_1,
      no2_1: formData.no2_1,
      no3_1: formData.no3_1,
      no4_1: formData.no4_1,
      no5_1: formData.no5_1,
      no1_2: formData.no1_2,
      no2_2: formData.no2_2,
      no3_2: formData.no3_2,
      no4_2: formData.no4_2,
      no5_2: formData.no5_2,
      promedio: formData.promedio,
      redondeo: formData.redondeo,
      desv_metodo: formData.desviacion_metodo,
      factor_correccion: formData.factorCorreccion || '100.12',
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-109-INNTEX-2012 RESISTENCIA AL RASGADO')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.grados,
      hr: formData.hr,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      termo: formData.idTermohigrometro || formData.id_termohigrometro || '',
      capacidad_equipo_rr: formData.capacidadEquipo,
      urdimbre: formData.urdimbre,
      trama: formData.trama,
      espec_rechz_rr: formData.especimenesRechazados,
      estado_espec_rr: formData.estadoEspecimenes,
      eq_digital: formData.eq_digital,
      tipo_material: formData.tipoMaterial,
      no1_1: formData.no1_urdimbre,
      no2_1: formData.no2_urdimbre,
      no3_1: formData.no3_urdimbre,
      no4_1: formData.no4_urdimbre,
      no5_1: formData.no5_urdimbre,
      no1_2: formData.no1_trama,
      no2_2: formData.no2_trama,
      no3_2: formData.no3_trama,
      no4_2: formData.no4_trama,
      no5_2: formData.no5_trama,
      hum_u1: formData.no1_urdimbre_2,
      hum_u2: formData.no2_urdimbre_2,
      hum_u3: formData.no3_urdimbre_2,
      hum_u4: formData.no4_urdimbre_2,
      hum_u5: formData.no5_urdimbre_2,
      hum_t1: formData.no1_trama_2,
      hum_t2: formData.no2_trama_2,
      hum_t3: formData.no3_trama_2,
      hum_t4: formData.no4_trama_2,
      hum_t5: formData.no5_trama_2,
      promedio1: formData.promedioUrdimbre,
      promedio2: formData.promedioTrama,
      promedio_u: formData.promedioUrdimbre,
      promedio_t: formData.promedioTrama,
      hum_pu: formData.promedioUrdimbre_2,
      hum_pt: formData.promedioTrama_2,
      texto_u: formData.textoPromedioUrdimbre,
      texto_t: formData.textoPromedioTrama,
      hum_tu: formData.textoPromedioUrdimbre_2,
      hum_tt: formData.textoPromedioTrama_2,
      coef_variacion: formData.coeficienteVariacion || formData.coefVariacion,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-7211/2-INNTEX-2015 DENSIDAD DE TEJIDO PLANO')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.temperatura || formData.grados,
      hr: formData.humedad || formData.hr,
      numero_solicitud: formData.numero_solicitud || formData.numeroSolicitud,
      termo: formData.id_termohigrometro || formData.idTermohigrometro || '',
      espec_u_ma: formData.especimenes_ensayados,
      espec_t_ma: formData.especimenes_ensayados_trama,
      urdimbre: formData.urdimbre,
      trama: formData.trama,
      no1_1: formData.no1_urdimbre,
      no2_1: formData.no2_urdimbre,
      no3_1: formData.no3_urdimbre,
      no4_1: formData.no4_urdimbre,
      no5_1: formData.no5_urdimbre,
      no1_2: formData.no1_trama,
      no2_2: formData.no2_trama,
      no3_2: formData.no3_trama,
      no4_2: formData.no4_trama,
      no5_2: formData.no5_trama,
      promedio1: formData.promedio_urdimbre,
      promedio2: formData.promedio_trama,
      promedio_u: formData.promedio_urdimbre,
      promedio_t: formData.promedio_trama,
      suma_u: formData.resultado_urdimbre,
      suma_t: formData.resultado_trama,
      resultado1: formData.resultado1,
      resultado2: formData.resultado2,
      desv_metodo: formData.desviacion_metodo || formData.distancia_medicion,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-134-INNTEX-2013 DENSIDAD DE TEJIDO DE PUNTO')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.grados,
      hr: formData.hr,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      termo: formData.idTermohigrometro || formData.id_termohigrometro || '',
      columnas: formData.columnas,
      mallas: formData.mallas,
      total_metros: formData.total_metros || formData.distanciaMedicion,
      t_modelo: formData.tamano_modelo_repetido,
      tam_modelo: formData.tamano_modelo,
      no1_1: formData.no1_columnas,
      no2_1: formData.no2_columnas,
      no3_1: formData.no3_columnas,
      no4_1: formData.no4_columnas,
      no5_1: formData.no5_columnas,
      no1_2: formData.no1_mallas,
      no2_2: formData.no2_mallas,
      no3_2: formData.no3_mallas,
      no4_2: formData.no4_mallas,
      no5_2: formData.no5_mallas,
      promedio_c: formData.promedioColumnas,
      promedio_m: formData.promedioMallas,
      redondeo_c: formData.redondeoColumnas,
      redondeo_m: formData.redondeoMallas,
      suma_c: formData.resultadoColumnas,
      suma_m: formData.resultadoMallas,
      desv_metodo: formData.desviacion_metodo,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('TIPO DE TEJIDO MET-7.2-11')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      resultado: formData.resultado,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('TIPO DE LIGAMENTO MET-7.2-12')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      imagen_url: formData.imagenUrl,
      tipo_tejido: formData.tipoTejido,
      res_plano_lig: formData.resultadoPlano,
      res_punto_lig: formData.resultadoPunto,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-275/5-INNTEX-2000 DENSIDAD LINEAL DE HILOS')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.grados,
      hr: formData.hr,
      numero_solicitud: formData.numero_solicitud || formData.numeroSolicitud,
      termo: formData.id_termohigrometro || formData.idTermohigrometro || '',
      mat_no_fibrosa: formData.sinEliminarMateria ? 'SI' : 'NO',
      hilos_ur: formData.hilosUr,
      hilos_tr: formData.hilosTr,
      longitud_ur: formData.longitudUr,
      longitud_tr: formData.longitudTr,
      gramos_ur: formData.gramosUr,
      gramos_tr: formData.gramosTr,
      no_tex_ur: formData.noTexUr,
      no_tex_tr: formData.noTexTr,
      otro_ur: formData.otroUr,
      otro_tr: formData.otroTr,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-172-INNTEX-2012 RESISTENCIA A LA ABRASIÓN PLANA TABER')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.gradosC || formData.grados,
      hr: formData.porcentajeHR || formData.hr,
      numero_solicitud: formData.numero_solicitud || formData.numeroSolicitud,
      termo: formData.id_termohigrometro || formData.idTermohigrometro || '',
      carga: formData.carga,
      nivel_vacio: formData.nivelVacio,
      rueda_abrasiva: formData.ruedaAbrasiva,
      alt_boquilla: formData.alturaBoquilla,
      hilo1: formData.hilo1,
      hilo2: formData.hilo2,
      hilo3: formData.hilo3,
      hilo4: formData.hilo4,
      hilo5: formData.hilo5,
      color1: formData.color1,
      color2: formData.color2,
      color3: formData.color3,
      color4: formData.color4,
      color5: formData.color5,
      frisa1: formData.frisa1,
      frisa2: formData.frisa2,
      frisa3: formData.frisa3,
      frisa4: formData.frisa4,
      frisa5: formData.frisa5,
      suma_h: formData.suma_h,
      suma_c: formData.suma_c,
      suma_f: formData.suma_f,
      resultado1: formData.resultadoHilo,
      resultado2: formData.resultadoColor,
      resultado3: formData.resultadoFrisa,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-9073/1-INNTEX-2018 MASA DE NO TEJIDOS')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.gradosC || formData.grados,
      hr: formData.porcentajeHR || formData.hr,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      termo: formData.idTermohigrometro || formData.id_termohigrometro || '',
      no1_1: formData.gramos1,
      no1_2: formData.resultado1,
      no2_1: formData.gramos2,
      no2_2: formData.resultado2,
      no3_1: formData.gramos3,
      no3_2: formData.resultado3,
      no4_1: formData.gramos4,
      no4_2: formData.resultado4,
      no5_1: formData.gramos5,
      no5_2: formData.resultado5,
      promedio: formData.promedio,
      coef_variacion: formData.coef_variacion,
      desv_metodo: formData.desv_metodo,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-4920-INNTEX-2017 RESISTENCIA AL HUMEDECIMIENTO SUPERFICIAL')) {
    const tempAgua = formData.temp27C ? '27°C' : formData.temp20C ? '20°C' : (formData.temp_agua || '')
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.gradosC || formData.grados,
      hr: formData.porcentajeHR || formData.hr,
      numero_solicitud: formData.numero_solicitud || formData.numeroSolicitud,
      termo: formData.id_termohigrometro || formData.idTermohigrometro || '',
      temp_agua: tempAgua,
      humed1: formData.humed1,
      humed2: formData.humed2,
      humed3: formData.humed3,
      desv_metodo: formData.desv_metodo,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-12945-3-INNTEX-2020 DETERMINACIÓN DE FRISAS')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.gradosC || formData.grados,
      hr: formData.porcentajeHR || formData.hr,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      termo: formData.idTermohigrometro || formData.id_termohigrometro || '',
      lavado: formData.lavado,
      secado: formData.secado,
      tiempo_ensayo: formData.tiempoEnsayo,
      tipo_revestimiento: formData.tipoRevest,
      patrones: formData.patronesClas,
      dispositivo: formData.flujoAire,
      no_observadores: formData.numObservadores,
      forma_espec: formData.formaEspecimen,
      desv_metodo: formData.DESV_METODO || formData.desv_metodo,
      // Primer ciclo - frisas
      '1frisas1_5': formData.frisas_5min_1,
      '2frisas1_5': formData.frisas_5min_2,
      '3frisas1_5': formData.frisas_5min_3,
      '1frisas1_15': formData.frisas_15min_1,
      '2frisas1_15': formData.frisas_15min_2,
      '3frisas1_15': formData.frisas_15min_3,
      '1frisas1_30': formData.frisas_30min_1,
      '2frisas1_30': formData.frisas_30min_2,
      '3frisas1_30': formData.frisas_30min_3,
      // Primer ciclo - vellosidad
      '1vellosidad1_5': formData.vellosidad1_5min_1,
      '2vellosidad1_5': formData.vellosidad1_5min_2,
      '3vellosidad1_5': formData.vellosidad1_5min_3,
      '1vellosidad1_15': formData.vellosidad1_15min_1,
      '2vellosidad1_15': formData.vellosidad1_15min_2,
      '3vellosidad1_15': formData.vellosidad1_15min_3,
      '1vellosidad1_30': formData.vellosidad1_30min_1,
      '2vellosidad1_30': formData.vellosidad1_30min_2,
      '3vellosidad1_30': formData.vellosidad1_30min_3,
      // Primer ciclo - emarañamiento
      '1enmaranamiento1_5': formData.emaranamiento1_5min_1,
      '2enmaranamiento1_5': formData.emaranamiento1_5min_2,
      '3enmaranamiento1_5': formData.emaranamiento1_5min_3,
      '1enmaranamiento1_15': formData.emaranamiento1_15min_1,
      '2enmaranamiento1_15': formData.emaranamiento1_15min_2,
      '3enmaranamiento1_15': formData.emaranamiento1_15min_3,
      '1enmaranamiento1_30': formData.emaranamiento1_30min_1,
      '2enmaranamiento1_30': formData.emaranamiento1_30min_2,
      '3enmaranamiento1_30': formData.emaranamiento1_30min_3,
      // Segundo ciclo - frisas
      '1frisas2_5': formData.frisas2_5min_1,
      '2frisas2_5': formData.frisas2_5min_2,
      '3frisas2_5': formData.frisas2_5min_3,
      '1frisas2_15': formData.frisas2_15min_1,
      '2frisas2_15': formData.frisas2_15min_2,
      '3frisas2_15': formData.frisas2_15min_3,
      '1frisas2_30': formData.frisas2_30min_1,
      '2frisas2_30': formData.frisas2_30min_2,
      '3frisas2_30': formData.frisas2_30min_3,
      // Segundo ciclo - vellosidad
      '1vellosidad2_5': formData.vellosidad2_5min_1,
      '2vellosidad2_5': formData.vellosidad2_5min_2,
      '3vellosidad2_5': formData.vellosidad2_5min_3,
      '1vellosidad2_15': formData.vellosidad2_15min_1,
      '2vellosidad2_15': formData.vellosidad2_15min_2,
      '3vellosidad2_15': formData.vellosidad2_15min_3,
      '1vellosidad2_30': formData.vellosidad2_30min_1,
      '2vellosidad2_30': formData.vellosidad2_30min_2,
      '3vellosidad2_30': formData.vellosidad2_30min_3,
      // Segundo ciclo - emarañamiento
      '1enmaranamiento2_5': formData.emaranamiento2_5min_1,
      '2enmaranamiento2_5': formData.emaranamiento2_5min_2,
      '3enmaranamiento2_5': formData.emaranamiento2_5min_3,
      '1enmaranamiento2_15': formData.emaranamiento2_15min_1,
      '2enmaranamiento2_15': formData.emaranamiento2_15min_2,
      '3enmaranamiento2_15': formData.emaranamiento2_15min_3,
      '1enmaranamiento2_30': formData.emaranamiento2_30min_1,
      '2enmaranamiento2_30': formData.emaranamiento2_30min_2,
      '3enmaranamiento2_30': formData.emaranamiento2_30min_3,
      // Promedios ciclo 1
      prom_frisas5: formData.frisas_5min_promedio,
      prom_frisas15: formData.frisas_15min_promedio,
      prom_frisas30: formData.frisas_30min_promedio,
      prom_vellosidad5: formData.vellosidad1_5min_promedio,
      prom_vellosidad15: formData.vellosidad1_15min_promedio,
      prom_vellosidad30: formData.vellosidad1_30min_promedio,
      prom_enmara5: formData.emaranamiento1_5min_promedio,
      prom_enmara15: formData.emaranamiento1_15min_promedio,
      prom_enmara30: formData.emaranamiento1_30min_promedio,
      // Promedios ciclo 2
      prom_frisas5_2: formData.frisas2_5min_promedio,
      prom_frisas15_2: formData.frisas2_15min_promedio,
      prom_frisas30_2: formData.frisas2_30min_promedio,
      prom_vellosidad5_2: formData.vellosidad2_5min_promedio,
      prom_vellosidad15_2: formData.vellosidad2_15min_promedio,
      prom_vellosidad30_2: formData.vellosidad2_30min_promedio,
      prom_enmara5_2: formData.emaranamiento2_5min_promedio,
      prom_enmara15_2: formData.emaranamiento2_15min_promedio,
      prom_enmara30_2: formData.emaranamiento2_30min_promedio,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-083-INNTEX-2020 EVALUACIÓN DE CONFECCIÓN')) {
    return {
      ...base,
      folio: formData.folio || null,
      numero_solicitud: formData.numero_solicitud || null,
      fecha: formData.fecha || null,
      hora: formData.hora || null,
      temperatura: formData.temperatura || null,
      humedad: formData.humedad || null,
      id_termohigrometro: formData.id_termohigrometro || null,
      especificacion: formData.especificacion || null,
      norma: formData.norma || null,
      prenda: formData.prenda || null,
      prenda_clave: formData.prenda_clave || null,
      clave: formData.clave || null,
      realizo: formData.realizo,
      superviso: formData.superviso,
      secciones_activas: formData.secciones_activas || [],
      titulo_descripcion: formData.titulo_descripcion || null,
      titulo_dimensiones: formData.titulo_dimensiones || null,
      titulo_confeccion: formData.titulo_confeccion || null,
      titulo_tipo_puntadas: formData.titulo_tipo_puntadas || null,
      nota_general: formData.nota_general || null,
      nota_descripcion: formData.nota_descripcion || null,
      nota_dimensiones: formData.nota_dimensiones || null,
      nota_confeccion: formData.nota_confeccion || null,
      nota_tipo_puntadas: formData.nota_tipo_puntadas || null,
      nota_etiquetado: formData.nota_etiquetado || null,
      nota_terminado: formData.nota_terminado || null,
      nota_tipos_hilos: formData.nota_tipos_hilos || null,
      nota_doc: formData.nota_doc || null,
      titulo_terminado: formData.titulo_terminado || null,
      titulo_tipos_hilos: formData.titulo_tipos_hilos || null,
      titulo_etiquetado: formData.titulo_etiquetado || null,
      descripcion_tabla: formData.descripcion_tabla || [],
      dimensiones: formData.dimensiones || [],
      confeccion: formData.confeccion || [],
      tipo_puntadas: formData.tipo_puntadas || [],
      etiquetado: formData.etiquetado || [],
      terminado: formData.terminado || [],
      tipos_hilos: formData.tipos_hilos || [],
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-229-1982 Determinación del pH')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      tiempo_agitacion: formData.tiempoAgitacion,
      sol_inicial: formData.pHSolucionInicial,
      sol_diluida: formData.pHSolucionDiluida,
      ph: formData.deltaPH,
      det_variacion: formData.detVariacion,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-221-1982 Determinación de las grasas')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      masa_inicial: formData.masaInicial,
      masa_final: formData.masaFinal,
      grasa: formData.porcentajeGrasa,
      det_variacion: formData.detVariacion,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-225-1982 Determinación de humedad en cuero')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      masa_inicial: formData.masaInicial,
      masa_final: formData.masaFinal,
      humedad: formData.porcentajeHumedad,
      det_variacion: formData.detVariacion,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-228-1982 Determinación de cenizas')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      masa_inicial: formData.masaInicialMuestra,
      cenizas_agua: formData.presenciaCenizasAgua,
      cenizas_insolubles: formData.masaCenizasInsolubles,
      cenizas_sulfatadas: formData.masaCenizasTotalesSulfatadas,
      cenizas_totales: formData.porcentajeCenizasTotales,
      det_variacion: formData.detVariacion || formData.DET_VARIACION,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-230-1982 Determinación del contenido de cromo')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      masa_cuero: formData.masaCuero,
      tiosulfato: formData.volumenTiosulfato,
      cromo: formData.porcentajeCromo,
      det_variacion: formData.detVariacion || formData.DET_VARIACION,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-073-INNTEX-2005 SOLIDEZ DEL COLOR AL FROTE')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.grados,
      hr: formData.hr,
      numero_solicitud: formData.noSolicitud || formData.numeroSolicitud || formData.numero_solicitud,
      termo: formData.idTermohigrometro || formData.id_termohigrometro || '',
      seco_tu: formData.secoUrdimbreTransferencia || formData.seco_urdimbre_transferencia,
      seco_tt: formData.secoTramaTransferencia || formData.seco_trama_transferencia,
      seco_cu: formData.secoUrdimbreCambioColor || formData.seco_urdimbre_cambioColor,
      seco_ct: formData.secoTramaCambioColor || formData.seco_trama_cambioColor,
      humedo_tu: formData.humedoUrdimbreTransferencia || formData.humedo_urdimbre_transferencia,
      humedo_tt: formData.humedoTramaTransferencia || formData.humedo_trama_transferencia,
      humedo_cu: formData.humedoUrdimbreCambioColor || formData.humedo_urdimbre_cambioColor,
      humedo_ct: formData.humedoTramaCambioColor || formData.humedo_trama_cambioColor,
      reportar_cambio_color: formData.reportarCambioColor === true,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-105-C06-INNTEX-2015 SOLIDEZ DEL COLOR AL LAVADO')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.grados,
      hr: formData.hr,
      numero_solicitud: formData.numeroSolicitud || formData.noSolicitud || formData.numero_solicitud,
      termo: formData.id_termohigrometro || formData.idTermohigrometro || '',
      metodo_c: formData.metodoCampo || formData.metodo,
      cloro_c: formData.cloroCampo || formData.cloroDisponible,
      tiempo_c: formData.tiempoCampo || formData.tiempo,
      temp_secado_c: formData.tempSecadoCampo || formData.tempSecado,
      vol_bano_c: formData.volBanoCampo || formData.volBano,
      temp_c: formData.temperaturaCampo || formData.temperatura,
      balines_c: formData.balinesCampo || formData.balines,
      ajuste_ph_c: formData.ajustePhCampo || formData.ajustePh,
      secado_c: formData.tipoSecadoCampo || formData.tipoSecado,
      detergente_c: formData.detergenteCampo || formData.detergente,
      acidulacion: formData.ACIDULACION || formData.acidulacion,
      multifibra: formData.tipoMultifibra,
      desv_metodo: formData.DESV_METODO || formData.desv_metodo,
      diacetato_dw: formData.diacetato_dw,
      algodon_dw: formData.algodon_blanqueado_dw,
      poliamida_dw: formData.poliamida_dw,
      poliester_dw: formData.poliester_dw,
      acrilico_dw: formData.acrilico_dw,
      lana_dw: formData.lana_dw,
      cambio_color_dw: formData.cambio_color_dw,
      diacetato_tv: formData.diacetato_tv,
      algodon_tv: formData.algodon_blanqueado_tv,
      poliamida_tv: formData.poliamida_tv,
      poliester_tv: formData.poliester_tv,
      acrilico_tv: formData.acrilico_tv,
      lana_tv: formData.viscosa_tv || formData.lana_tv,
      cambio_color_tv: formData.cambio_color_tv,
      diacetato_dw_label: formData.diacetato_dw_label,
      diacetato_tv_label: formData.diacetato_tv_label,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-105-E04-INNTEX-2019 SOLIDEZ DEL COLOR AL SUDOR')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      pos_especimenes: formData.posicionEspecimenes || formData.FORMA_EVALUACION,
      tipo_multifibra: formData.TIPO_MULTIFIBRA || formData.tipoMultifibra,
      forma_evaluacion: formData.FORMA_EVALUACION || formData.forma_evaluacion,
      metodo_c: formData.METODO_C || formData.metodo_c,
      diacetato_ac: formData.diacetato_acido,
      algodon_ac: formData.algodon_blanqueado_acido,
      poliamida_ac: formData.poliamida_acido,
      poliester_ac: formData.poliester_acido,
      acrilico_ac: formData.acrilico_acido,
      lana_ac: formData.lana_acido,
      cambio_color_ac: formData.cambio_color_acido,
      diacetato_al: formData.diacetato_alcalino,
      algodon_al: formData.algodon_blanqueado_alcalino,
      poliamida_al: formData.poliamida_alcalino,
      poliester_al: formData.poliester_alcalino,
      acrilico_al: formData.acrilico_alcalino,
      lana_al: formData.lana_alcalino,
      cambio_color_al: formData.cambio_color_alcalino,
      promedio1: formData.promedio1,
      promedio2: formData.promedio2,
      resultado1: formData.resultado1,
      resultado2: formData.resultado2,
      diacetato_acido_label: formData.diacetato_acido_label,
      diacetato_alcalino_label: formData.diacetato_alcalino_label,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('TIPO DE ACABADO MET-7.2-19')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numero_solicitud || formData.numeroSolicitud,
      resultado: formData.resultado,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-5077-INNTEX-2015 / NMX-A-6330-INNTEX-2015 CAMBIOS DIMENSIONALES')) {
    return {
      ...base,
      fecha: formData.fecha,
      hora: formData.hora,
      grados: formData.grados,
      hr: formData.hr,
      numero_solicitud: formData.numero_solicitud || formData.numeroSolicitud,
      termo: formData.id_termohigrometro || formData.idTermohigrometro || '',
      tipo_carga: formData.tipo_de_carga,
      ciclos: formData.ciclos,
      lavado: formData.lavado,
      secado: formData.secado,
      tipo_lavadora: formData.tipo_de_lavadora || formData.tipo_lavado_ora,
      tipo_secadora: formData.tipo_de_secado_ora,
      dim_especim: formData.DIM_ESPECIM || formData.dim_especim,
      m1_uc_mi1: formData.m1_urd_inicial_1,
      m1_uc_mi2: formData.m1_urd_inicial_2,
      m1_uc_mi3: formData.m1_urd_inicial_3,
      m1_uc_mipro: formData.m1_urd_inicial_prom,
      m1_uc_mf1: formData.m1_urd_final_1,
      m1_uc_mf2: formData.m1_urd_final_2,
      m1_uc_mf3: formData.m1_urd_final_3,
      m1_uc_mfpro: formData.m1_urd_final_prom,
      m1_uc_cambio: formData.m1_urd_cambio,
      m1_tm_mi1: formData.m1_tra_inicial_1,
      m1_tm_mi2: formData.m1_tra_inicial_2,
      m1_tm_mi3: formData.m1_tra_inicial_3,
      m1_tm_mipro: formData.m1_tra_inicial_prom,
      m1_tm_mf1: formData.m1_tra_final_1,
      m1_tm_mf2: formData.m1_tra_final_2,
      m1_tm_mf3: formData.m1_tra_final_3,
      m1_tm_mfpro: formData.m1_tra_final_prom,
      m1_tm_cambio: formData.m1_tra_cambio,
      m2_uc_mi1: formData.m2_urd_inicial_1,
      m2_uc_mi2: formData.m2_urd_inicial_2,
      m2_uc_mi3: formData.m2_urd_inicial_3,
      m2_uc_mipro: formData.m2_urd_inicial_prom,
      m2_uc_mf1: formData.m2_urd_final_1,
      m2_uc_mf2: formData.m2_urd_final_2,
      m2_uc_mf3: formData.m2_urd_final_3,
      m2_uc_mfpro: formData.m2_urd_final_prom,
      m2_uc_cambio: formData.m2_urd_cambio,
      m2_tm_mi1: formData.m2_tra_inicial_1,
      m2_tm_mi2: formData.m2_tra_inicial_2,
      m2_tm_mi3: formData.m2_tra_inicial_3,
      m2_tm_mipro: formData.m2_tra_inicial_prom,
      m2_tm_mf1: formData.m2_tra_final_1,
      m2_tm_mf2: formData.m2_tra_final_2,
      m2_tm_mf3: formData.m2_tra_final_3,
      m2_tm_mfpro: formData.m2_tra_final_prom,
      m2_tm_cambio: formData.m2_tra_cambio,
      promedio_uc: formData.promedio_urdimbre,
      redondeo_uc: formData.redondeo_urdimbre,
      promedio_tm: formData.promedio_trama,
      redondeo_tm: formData.redondeo_trama,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('ANÁLISIS QUÍMICO CUALITATIVO Y CUANTITATIVO')) {
    return {
      ...base,
      fecha: formData.fecha,
      numero_solicitud: formData.numeroSolicitud || formData.numero_solicitud,
      opcion_nmx: formData.OPCION_NMX || formData.normaSeleccionada,
      opciones: formData.opciones,
      pretratamiento: formData.pretratamiento === 'con_pretratamiento' ? 'Si' : formData.pretratamiento === 'sin_pretratamiento' ? 'No' : formData.pretratamiento,
      resultado_quimico: formData.resultadoQuimico,
      realizo: formData.realizo,
      superviso: formData.superviso,
      observaciones: formData.observaciones,
      sustancia: formData.sustancia || null,
      reportar_apresto: formData.reportarApresto || null,
      p0: formData.p0 || null,
      pf: formData.pf || null,
      fibra: formData.fibra || null,
      m0: formData.m0 || null,
      m1: formData.m1 || null,
      d: formData.d || null,
      fibra_ro: formData.fibra_ro || null,
      fibra_cs: formData.fibra_cs || null,
      combustion: formData.combustion || null,
      microscopia: formData.microscopia || null,
      analisis_quimico: formData.analisis_quimico || null,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-105-D01-INNTEX-2020')) {
    return {
      ...base,
      numero_solicitud: formData.numero_solicitud,
      fecha: formData.fecha,
      solvente: formData.solvente,
      multifibra: formData.multifibra,
      diacetato_dw: formData.diacetato_dw,
      algodon_dw: formData.algodon_dw,
      poliamida_dw: formData.poliamida_dw,
      poliester_dw: formData.poliester_dw,
      acrilico_dw: formData.acrilico_dw,
      lana_dw: formData.lana_dw,
      cambio_color_dw: formData.cambio_color_dw,
      triacetato_tv: formData.triacetato_tv,
      algodon_tv: formData.algodon_tv,
      poliamida_tv: formData.poliamida_tv,
      poliester_tv: formData.poliester_tv,
      acrilico_tv: formData.acrilico_tv,
      viscosa_tv: formData.viscosa_tv,
      cambio_color_tv: formData.cambio_color_tv,
      observaciones: formData.observaciones,
      desv_metodo: formData.desv_metodo,
      realizo: formData.realizo,
      autorizo: formData.autorizo,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-105-B02-INNTEX-2019')) {
    return {
      ...base,
      numero_solicitud: formData.numero_solicitud,
      fecha: formData.fecha,
      ciclo_exposicion: formData.ciclo_exposicion,
      temp_estandar_negro: formData.temp_estandar_negro,
      temp_panel_negro: formData.temp_panel_negro,
      humedad_relativa: formData.humedad_relativa,
      irradiacion: formData.irradiacion,
      longitud_onda: formData.longitud_onda,
      tiempo_exposicion: formData.tiempo_exposicion,
      exposicion_radiante: formData.exposicion_radiante,
      grado_escala_gris: formData.grado_escala_gris,
      observaciones: formData.observaciones,
      desv_metodo: formData.desv_metodo,
      realizo: formData.realizo,
      autorizo: formData.autorizo,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-A-059/1-INNTEX-2019')) {
    const d = formData
    const base059: any = {
      ...base,
      numero_solicitud: d.numero_solicitud,
      fecha: d.fecha, hora: d.hora, temperatura: d.temperatura, hr: d.hr,
      id_termohigrometro: d.id_termohigrometro,
      longitud_ensayo: d.longitud_ensayo,
      velocidad_alargamiento: d.velocidad_alargamiento,
      ancho_tira: d.ancho_tira,
      estado_especimenes: Array.isArray(d.estado_especimenes) ? d.estado_especimenes.join(', ') : d.estado_especimenes,
      num_especimenes: d.num_especimenes,
      especimenes_rechazados: d.especimenes_rechazados,
      num_hilos_tira: d.num_hilos_tira,
      tablas_activas: Array.isArray(d.tablas_activas) ? d.tablas_activas.join(', ') : d.tablas_activas,
      reportar: d.reportar !== false,
      tiene_metodo_muestreo: !!d.tiene_metodo_muestreo,
      metodo_muestreo: d.metodo_muestreo || '',
      observaciones: d.observaciones, desv_metodo: d.desv_metodo,
      realizo: d.realizo, superviso: d.superviso,
      aceptado: d.ACEPTADO || d.aceptado || null,
      razon_rechazo: d.RAZON_RECHAZO || d.razon_rechazo || null,
    }
    for (const t of ['fm','fr','afm','ar']) {
      for (let i = 1; i <= 5; i++) {
        base059[`${t}_u${i}`] = d[`${t}_u${i}`]
        base059[`${t}_t${i}`] = d[`${t}_t${i}`]
      }
      base059[`${t}_prom_u`] = d[`${t}_prom_u`]
      base059[`${t}_prom_t`] = d[`${t}_prom_t`]
      base059[`${t}_red_u`] = d[`${t}_red_u`]
      base059[`${t}_red_t`] = d[`${t}_red_t`]
    }
    return base059
  }

  if (prueba.includes('NMX-A-059/2-INNTEX-2019') || prueba.includes('059/2') || prueba.includes('Grab')) {
    const d = formData
    return {
      ...base,
      numero_solicitud: d.numero_solicitud,
      fecha: d.fecha, hora: d.hora, temperatura: d.temperatura, hr: d.hr,
      id_termohigrometro: d.id_termohigrometro,
      especimenes_u: d.especimenes_u, especimenes_t: d.especimenes_t,
      longitud_ensayo: d.longitud_ensayo,
      especimenes_rechazados: d.especimenes_rechazados,
      estado_especimenes: Array.isArray(d.estado_especimenes) ? d.estado_especimenes.join(', ') : d.estado_especimenes,
      no1_u: d.no1_u, no2_u: d.no2_u, no3_u: d.no3_u, no4_u: d.no4_u, no5_u: d.no5_u,
      no1_t: d.no1_t, no2_t: d.no2_t, no3_t: d.no3_t, no4_t: d.no4_t, no5_t: d.no5_t,
      promedio_u: d.promedio_u, redondeo_u: d.redondeo_u,
      promedio_t: d.promedio_t, redondeo_t: d.redondeo_t,
      reportar: d.reportar !== false,
      tiene_metodo_muestreo: !!d.tiene_metodo_muestreo,
      metodo_muestreo: d.metodo_muestreo || '',
      observaciones: d.observaciones, desv_metodo: d.desv_metodo,
      realizo: d.realizo, superviso: d.superviso,
      aceptado: d.ACEPTADO || d.aceptado || null,
      razon_rechazo: d.RAZON_RECHAZO || d.razon_rechazo || null,
    }
  }

  if (prueba.includes('AATCC TM127-2017')) {
    const d = formData
    return {
      ...base,
      numero_solicitud: d.numero_solicitud,
      fecha: d.fecha, hora: d.hora, temperatura: d.temperatura, hr: d.hr,
      id_termohigrometro: d.id_termohigrometro,
      tipo_material: d.tipo_material, tipo_agua: d.tipo_agua,
      temp_agua: d.temp_agua, cara_delantera: d.cara_delantera,
      no1: d.no1, no2: d.no2, no3: d.no3, promedio: d.promedio,
      observaciones: d.observaciones, desv_metodo: d.desv_metodo,
      realizo: d.realizo, superviso: d.superviso,
      aceptado: d.ACEPTADO || d.aceptado || null,
      razon_rechazo: d.RAZON_RECHAZO || d.razon_rechazo || null,
    }
  }

  if (prueba.includes('PRUEBA ADICIONAL')) {
    return {
      ...base,
      nombre_prueba: formData.nombre_prueba,
      fecha: formData.fecha,
      nota_doc: formData.nota_doc,
      observaciones: formData.observaciones,
      realizo: formData.realizo,
      superviso: formData.superviso,
      aceptado: formData.ACEPTADO || formData.aceptado || null,
      razon_rechazo: formData.RAZON_RECHAZO || formData.razon_rechazo || null,
    }
  }

  if (prueba.includes('NMX-S-051-1989')) {
    const d = formData
    return {
      ...base,
      numero_solicitud: d.numero_solicitud, fecha: d.fecha,
      inicio_hora: d.inicio_hora, inicio_temp: d.inicio_temp,
      inicio_hr: d.inicio_hr, inicio_termo: d.inicio_termo,
      fin_hora: d.fin_hora, fin_temp: d.fin_temp,
      fin_hr: d.fin_hr, fin_termo: d.fin_termo,
      flexiones_programadas: d.flexiones_programadas,
      tipo_agua: d.tipo_agua, tiempo_inmersion: d.tiempo_inmersion,
      seco_100_con: d.seco_100_con, seco_100_sin: d.seco_100_sin,
      seco_1000_con: d.seco_1000_con, seco_1000_sin: d.seco_1000_sin,
      seco_10000_con: d.seco_10000_con, seco_10000_sin: d.seco_10000_sin,
      seco_20000_con: d.seco_20000_con, seco_20000_sin: d.seco_20000_sin,
      seco_48000_con: d.seco_48000_con, seco_48000_sin: d.seco_48000_sin,
      hum_100_con: d.hum_100_con, hum_100_sin: d.hum_100_sin,
      hum_1000_con: d.hum_1000_con, hum_1000_sin: d.hum_1000_sin,
      hum_10000_con: d.hum_10000_con, hum_10000_sin: d.hum_10000_sin,
      hum_18000_con: d.hum_18000_con, hum_18000_sin: d.hum_18000_sin,
      flex_prom_seco: d.flex_prom_seco, flex_prom_hum: d.flex_prom_hum,
      dano_seco: d.dano_seco, dano_hum: d.dano_hum,
      observaciones: d.observaciones, desv_metodo: d.desv_metodo,
      realizo: d.realizo, autorizo: d.autorizo,
      aceptado: d.ACEPTADO || d.aceptado || null,
      razon_rechazo: d.RAZON_RECHAZO || d.razon_rechazo || null,
    }
  }

  // Default: send all formData fields (strip known frontend-only fields)
  const { ROW_ID, PRUEBA, PEDIDO, PEDIDO_ID, nomId, ...rest } = formData
  return { ...base, ...rest }
}

/**
 * Convert a Supabase row back into form field names (for REVISAR view).
 * This is the inverse of formDataToSupabase.
 */
export function supabaseToFormData(prueba: string, row: any): Record<string, any> {
  const get = (k: string) => (row[k] !== undefined && row[k] !== null ? String(row[k]) : '')

  if (prueba.includes('NMX-A-3801-INNTEX-2012')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      grados: get('grados'),
      hr: get('hr'),
      numero_solicitud: get('numero_solicitud'),
      id_termohigrometro: get('termo'),
      no1_1: get('no1_1'),
      no2_1: get('no2_1'),
      no3_1: get('no3_1'),
      no4_1: get('no4_1'),
      no5_1: get('no5_1'),
      no1_2: get('no1_2'),
      no2_2: get('no2_2'),
      no3_2: get('no3_2'),
      no4_2: get('no4_2'),
      no5_2: get('no5_2'),
      promedio: get('promedio'),
      redondeo: get('redondeo'),
      desviacion_metodo: get('desv_metodo'),
      factorCorreccion: get('factor_correccion') || '100.12',
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-109-INNTEX-2012 RESISTENCIA AL RASGADO')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      grados: get('grados'),
      hr: get('hr'),
      numeroSolicitud: get('numero_solicitud'),
      idTermohigrometro: get('termo'),
      capacidadEquipo: get('capacidad_equipo_rr'),
      urdimbre: get('urdimbre'),
      trama: get('trama'),
      especimenesRechazados: get('espec_rechz_rr'),
      estadoEspecimenes: get('estado_espec_rr'),
      tipoMaterial: get('tipo_material'),
      no1_urdimbre: get('no1_1'),
      no2_urdimbre: get('no2_1'),
      no3_urdimbre: get('no3_1'),
      no4_urdimbre: get('no4_1'),
      no5_urdimbre: get('no5_1'),
      no1_trama: get('no1_2'),
      no2_trama: get('no2_2'),
      no3_trama: get('no3_2'),
      no4_trama: get('no4_2'),
      no5_trama: get('no5_2'),
      promedioUrdimbre: get('promedio_u'),
      promedioTrama: get('promedio_t'),
      textoPromedioUrdimbre: get('texto_u'),
      textoPromedioTrama: get('texto_t'),
      coeficienteVariacion: get('coef_variacion'),
      no1_urdimbre_2: get('hum_u1'),
      no2_urdimbre_2: get('hum_u2'),
      no3_urdimbre_2: get('hum_u3'),
      no4_urdimbre_2: get('hum_u4'),
      no5_urdimbre_2: get('hum_u5'),
      no1_trama_2: get('hum_t1'),
      no2_trama_2: get('hum_t2'),
      no3_trama_2: get('hum_t3'),
      no4_trama_2: get('hum_t4'),
      no5_trama_2: get('hum_t5'),
      promedioUrdimbre_2: get('hum_pu'),
      promedioTrama_2: get('hum_pt'),
      textoPromedioUrdimbre_2: get('hum_tu'),
      textoPromedioTrama_2: get('hum_tt'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-7211/2-INNTEX-2015 DENSIDAD DE TEJIDO PLANO')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      temperatura: get('grados'),
      humedad: get('hr'),
      numero_solicitud: get('numero_solicitud'),
      id_termohigrometro: get('termo'),
      especimenes_ensayados: get('espec_u_ma'),
      especimenes_ensayados_trama: get('espec_t_ma'),
      urdimbre: get('urdimbre'),
      trama: get('trama'),
      no1_urdimbre: get('no1_1'),
      no2_urdimbre: get('no2_1'),
      no3_urdimbre: get('no3_1'),
      no4_urdimbre: get('no4_1'),
      no5_urdimbre: get('no5_1'),
      promedio_urdimbre: get('promedio_u'),
      no1_trama: get('no1_2'),
      no2_trama: get('no2_2'),
      no3_trama: get('no3_2'),
      no4_trama: get('no4_2'),
      no5_trama: get('no5_2'),
      promedio_trama: get('promedio_t'),
      resultado_urdimbre: get('suma_u'),
      resultado_trama: get('suma_t'),
      desviacion_metodo: get('desv_metodo'),
      distancia_medicion: get('desv_metodo'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-134-INNTEX-2013 DENSIDAD DE TEJIDO DE PUNTO')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      grados: get('grados'),
      hr: get('hr'),
      numeroSolicitud: get('numero_solicitud'),
      idTermohigrometro: get('termo'),
      columnas: get('columnas'),
      mallas: get('mallas'),
      distanciaMedicion: get('total_metros'),
      total_metros: get('total_metros'),
      tamano_modelo: get('tam_modelo'),
      tamano_modelo_repetido: get('t_modelo'),
      no1_columnas: get('no1_1'),
      no2_columnas: get('no2_1'),
      no3_columnas: get('no3_1'),
      no4_columnas: get('no4_1'),
      no5_columnas: get('no5_1'),
      no1_mallas: get('no1_2'),
      no2_mallas: get('no2_2'),
      no3_mallas: get('no3_2'),
      no4_mallas: get('no4_2'),
      no5_mallas: get('no5_2'),
      promedioColumnas: get('promedio_c'),
      promedioMallas: get('promedio_m'),
      resultadoColumnas: get('suma_c'),
      resultadoMallas: get('suma_m'),
      desviacion_metodo: get('desv_metodo'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('TIPO DE TEJIDO MET-7.2-11')) {
    return {
      fecha: get('fecha'),
      numeroSolicitud: get('numero_solicitud'),
      resultado: get('resultado'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('TIPO DE LIGAMENTO MET-7.2-12')) {
    return {
      fecha: get('fecha'),
      numeroSolicitud: get('numero_solicitud'),
      imagenUrl: get('imagen_url'),
      tipoTejido: get('tipo_tejido'),
      resultadoPlano: get('res_plano_lig'),
      resultadoPunto: get('res_punto_lig'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-275/5-INNTEX-2000 DENSIDAD LINEAL DE HILOS')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      grados: get('grados'),
      hr: get('hr'),
      numero_solicitud: get('numero_solicitud'),
      id_termohigrometro: get('termo'),
      sinEliminarMateria: row.mat_no_fibrosa === 'SI' || row.mat_no_fibrosa === true,
      hilosUr: get('hilos_ur'),
      hilosTr: get('hilos_tr'),
      longitudUr: get('longitud_ur'),
      longitudTr: get('longitud_tr'),
      gramosUr: get('gramos_ur'),
      gramosTr: get('gramos_tr'),
      noTexUr: get('no_tex_ur'),
      noTexTr: get('no_tex_tr'),
      otroUr: get('otro_ur'),
      otroTr: get('otro_tr'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-172-INNTEX-2012 RESISTENCIA A LA ABRASIÓN PLANA TABER')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      gradosC: get('grados'),
      porcentajeHR: get('hr'),
      numero_solicitud: get('numero_solicitud'),
      id_termohigrometro: get('termo'),
      carga: get('carga'),
      nivelVacio: get('nivel_vacio'),
      ruedaAbrasiva: get('rueda_abrasiva'),
      alturaBoquilla: get('alt_boquilla'),
      hilo1: get('hilo1'),
      hilo2: get('hilo2'),
      hilo3: get('hilo3'),
      hilo4: get('hilo4'),
      hilo5: get('hilo5'),
      resultadoHilo: get('resultado1'),
      color1: get('color1'),
      color2: get('color2'),
      color3: get('color3'),
      color4: get('color4'),
      color5: get('color5'),
      resultadoColor: get('resultado2'),
      frisa1: get('frisa1'),
      frisa2: get('frisa2'),
      frisa3: get('frisa3'),
      frisa4: get('frisa4'),
      frisa5: get('frisa5'),
      resultadoFrisa: get('resultado3'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-9073/1-INNTEX-2018 MASA DE NO TEJIDOS')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      gradosC: get('grados'),
      porcentajeHR: get('hr'),
      numeroSolicitud: get('numero_solicitud'),
      idTermohigrometro: get('termo'),
      gramos1: get('no1_1'),
      resultado1: get('no1_2'),
      gramos2: get('no2_1'),
      resultado2: get('no2_2'),
      gramos3: get('no3_1'),
      resultado3: get('no3_2'),
      gramos4: get('no4_1'),
      resultado4: get('no4_2'),
      gramos5: get('no5_1'),
      resultado5: get('no5_2'),
      promedio: get('promedio'),
      coef_variacion: get('coef_variacion'),
      desv_metodo: get('desv_metodo'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-4920-INNTEX-2017 RESISTENCIA AL HUMEDECIMIENTO SUPERFICIAL')) {
    const tempAgua = String(get('temp_agua') || '').trim()
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      gradosC: get('grados'),
      porcentajeHR: get('hr'),
      numero_solicitud: get('numero_solicitud'),
      id_termohigrometro: get('termo'),
      temp20C: /20/.test(tempAgua),
      temp27C: /27/.test(tempAgua),
      humed1: get('humed1'),
      humed2: get('humed2'),
      humed3: get('humed3'),
      desv_metodo: get('desv_metodo'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-12945-3-INNTEX-2020 DETERMINACIÓN DE FRISAS')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      gradosC: get('grados'),
      porcentajeHR: get('hr'),
      numeroSolicitud: get('numero_solicitud'),
      idTermohigrometro: get('termo'),
      lavado: get('lavado'),
      secado: get('secado'),
      tiempoEnsayo: get('tiempo_ensayo'),
      tipoRevest: get('tipo_revestimiento'),
      patronesClas: get('patrones'),
      flujoAire: get('dispositivo'),
      numObservadores: get('no_observadores'),
      formaEspecimen: get('forma_espec'),
      DESV_METODO: get('desv_metodo'),
      frisas_5min_1: get('1frisas1_5'),
      frisas_5min_2: get('2frisas1_5'),
      frisas_5min_3: get('3frisas1_5'),
      frisas_15min_1: get('1frisas1_15'),
      frisas_15min_2: get('2frisas1_15'),
      frisas_15min_3: get('3frisas1_15'),
      frisas_30min_1: get('1frisas1_30'),
      frisas_30min_2: get('2frisas1_30'),
      frisas_30min_3: get('3frisas1_30'),
      vellosidad1_5min_1: get('1vellosidad1_5'),
      vellosidad1_5min_2: get('2vellosidad1_5'),
      vellosidad1_5min_3: get('3vellosidad1_5'),
      vellosidad1_15min_1: get('1vellosidad1_15'),
      vellosidad1_15min_2: get('2vellosidad1_15'),
      vellosidad1_15min_3: get('3vellosidad1_15'),
      vellosidad1_30min_1: get('1vellosidad1_30'),
      vellosidad1_30min_2: get('2vellosidad1_30'),
      vellosidad1_30min_3: get('3vellosidad1_30'),
      emaranamiento1_5min_1: get('1enmaranamiento1_5'),
      emaranamiento1_5min_2: get('2enmaranamiento1_5'),
      emaranamiento1_5min_3: get('3enmaranamiento1_5'),
      emaranamiento1_15min_1: get('1enmaranamiento1_15'),
      emaranamiento1_15min_2: get('2enmaranamiento1_15'),
      emaranamiento1_15min_3: get('3enmaranamiento1_15'),
      emaranamiento1_30min_1: get('1enmaranamiento1_30'),
      emaranamiento1_30min_2: get('2enmaranamiento1_30'),
      emaranamiento1_30min_3: get('3enmaranamiento1_30'),
      frisas2_5min_1: get('1frisas2_5'),
      frisas2_5min_2: get('2frisas2_5'),
      frisas2_5min_3: get('3frisas2_5'),
      frisas2_15min_1: get('1frisas2_15'),
      frisas2_15min_2: get('2frisas2_15'),
      frisas2_15min_3: get('3frisas2_15'),
      frisas2_30min_1: get('1frisas2_30'),
      frisas2_30min_2: get('2frisas2_30'),
      frisas2_30min_3: get('3frisas2_30'),
      vellosidad2_5min_1: get('1vellosidad2_5'),
      vellosidad2_5min_2: get('2vellosidad2_5'),
      vellosidad2_5min_3: get('3vellosidad2_5'),
      vellosidad2_15min_1: get('1vellosidad2_15'),
      vellosidad2_15min_2: get('2vellosidad2_15'),
      vellosidad2_15min_3: get('3vellosidad2_15'),
      vellosidad2_30min_1: get('1vellosidad2_30'),
      vellosidad2_30min_2: get('2vellosidad2_30'),
      vellosidad2_30min_3: get('3vellosidad2_30'),
      emaranamiento2_5min_1: get('1enmaranamiento2_5'),
      emaranamiento2_5min_2: get('2enmaranamiento2_5'),
      emaranamiento2_5min_3: get('3enmaranamiento2_5'),
      emaranamiento2_15min_1: get('1enmaranamiento2_15'),
      emaranamiento2_15min_2: get('2enmaranamiento2_15'),
      emaranamiento2_15min_3: get('3enmaranamiento2_15'),
      emaranamiento2_30min_1: get('1enmaranamiento2_30'),
      emaranamiento2_30min_2: get('2enmaranamiento2_30'),
      emaranamiento2_30min_3: get('3enmaranamiento2_30'),
      frisas_5min_promedio: get('prom_frisas5'),
      frisas_15min_promedio: get('prom_frisas15'),
      frisas_30min_promedio: get('prom_frisas30'),
      vellosidad1_5min_promedio: get('prom_vellosidad5'),
      vellosidad1_15min_promedio: get('prom_vellosidad15'),
      vellosidad1_30min_promedio: get('prom_vellosidad30'),
      emaranamiento1_5min_promedio: get('prom_enmara5'),
      emaranamiento1_15min_promedio: get('prom_enmara15'),
      emaranamiento1_30min_promedio: get('prom_enmara30'),
      frisas2_5min_promedio: get('prom_frisas5_2'),
      frisas2_15min_promedio: get('prom_frisas15_2'),
      frisas2_30min_promedio: get('prom_frisas30_2'),
      vellosidad2_5min_promedio: get('prom_vellosidad5_2'),
      vellosidad2_15min_promedio: get('prom_vellosidad15_2'),
      vellosidad2_30min_promedio: get('prom_vellosidad30_2'),
      emaranamiento2_5min_promedio: get('prom_enmara5_2'),
      emaranamiento2_15min_promedio: get('prom_enmara15_2'),
      emaranamiento2_30min_promedio: get('prom_enmara30_2'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-083-INNTEX-2020 EVALUACIÓN DE CONFECCIÓN')) {
    return {
      folio: get('folio'),
      numero_solicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      hora: get('hora'),
      temperatura: get('temperatura'),
      humedad: get('humedad'),
      id_termohigrometro: get('id_termohigrometro'),
      especificacion: get('especificacion'),
      norma: get('norma'),
      prenda: get('prenda'),
      prenda_clave: get('prenda_clave'),
      clave: get('clave'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      secciones_activas: parseJsonArr(row['secciones_activas']),
      titulo_descripcion: get('titulo_descripcion'),
      titulo_dimensiones: get('titulo_dimensiones'),
      titulo_confeccion: get('titulo_confeccion'),
      titulo_tipo_puntadas: get('titulo_tipo_puntadas'),
      nota_general: get('nota_general'),
      nota_descripcion: get('nota_descripcion'),
      nota_dimensiones: get('nota_dimensiones'),
      nota_confeccion: get('nota_confeccion'),
      nota_tipo_puntadas: get('nota_tipo_puntadas'),
      nota_etiquetado: get('nota_etiquetado'),
      nota_terminado: get('nota_terminado'),
      nota_tipos_hilos: get('nota_tipos_hilos'),
      nota_doc: get('nota_doc'),
      titulo_terminado: get('titulo_terminado'),
      titulo_tipos_hilos: get('titulo_tipos_hilos'),
      titulo_etiquetado: get('titulo_etiquetado'),
      descripcion_tabla: parseJsonArr(row['descripcion_tabla']),
      dimensiones: parseJsonArr(row['dimensiones']),
      confeccion: parseJsonArr(row['confeccion']),
      tipo_puntadas: parseJsonArr(row['tipo_puntadas']),
      etiquetado: parseJsonArr(row['etiquetado']),
      terminado: parseJsonArr(row['terminado']),
      tipos_hilos: parseJsonArr(row['tipos_hilos']),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-229-1982 Determinación del pH')) {
    return {
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      tiempoAgitacion: get('tiempo_agitacion'),
      pHSolucionInicial: get('sol_inicial'),
      pHSolucionDiluida: get('sol_diluida'),
      deltaPH: get('ph'),
      detVariacion: get('det_variacion'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-221-1982 Determinación de las grasas')) {
    return {
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      masaInicial: get('masa_inicial'),
      masaFinal: get('masa_final'),
      porcentajeGrasa: get('grasa'),
      detVariacion: get('det_variacion'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-225-1982 Determinación de humedad en cuero')) {
    return {
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      masaInicial: get('masa_inicial'),
      masaFinal: get('masa_final'),
      porcentajeHumedad: get('humedad'),
      detVariacion: get('det_variacion'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-228-1982 Determinación de cenizas')) {
    return {
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      masaInicialMuestra: get('masa_inicial'),
      presenciaCenizasAgua: get('cenizas_agua'),
      masaCenizasInsolubles: get('cenizas_insolubles'),
      masaCenizasTotalesSulfatadas: get('cenizas_sulfatadas'),
      porcentajeCenizasTotales: get('cenizas_totales'),
      DET_VARIACION: get('det_variacion'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-230-1982 Determinación del contenido de cromo')) {
    return {
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      metodo: 'ÁCIDO PERCLÓRICO',
      masaCuero: get('masa_cuero'),
      volumenTiosulfato: get('tiosulfato'),
      porcentajeCromo: get('cromo'),
      DET_VARIACION: get('det_variacion'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-073-INNTEX-2005 SOLIDEZ DEL COLOR AL FROTE')) {
    return {
      noSolicitud: get('numero_solicitud'),
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      hora: get('hora'),
      grados: get('grados'),
      hr: get('hr'),
      idTermohigrometro: get('termo'),
      secoUrdimbreTransferencia: get('seco_tu'),
      secoTramaTransferencia: get('seco_tt'),
      secoUrdimbreCambioColor: get('seco_cu'),
      secoTramaCambioColor: get('seco_ct'),
      humedoUrdimbreTransferencia: get('humedo_tu'),
      humedoTramaTransferencia: get('humedo_tt'),
      humedoUrdimbreCambioColor: get('humedo_cu'),
      humedoTramaCambioColor: get('humedo_ct'),
      reportarCambioColor: row.reportar_cambio_color === true,
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-105-C06-INNTEX-2015 SOLIDEZ DEL COLOR AL LAVADO')) {
    return {
      noSolicitud: '',
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      hora: get('hora'),
      metodoCampo: get('metodo_c'),
      cloroCampo: get('cloro_c'),
      tiempoCampo: get('tiempo_c'),
      tempSecadoCampo: get('temp_secado_c'),
      volBanoCampo: get('vol_bano_c'),
      temperaturaCampo: get('temp_c'),
      balinesCampo: get('balines_c'),
      ajustePhCampo: get('ajuste_ph_c'),
      tipoSecadoCampo: get('secado_c'),
      detergenteCampo: get('detergente_c'),
      ACIDULACION: get('acidulacion'),
      tipoMultifibra: get('multifibra'),
      DESV_METODO: get('desv_metodo'),
      diacetato_dw: get('diacetato_dw'),
      algodon_blanqueado_dw: get('algodon_dw'),
      poliamida_dw: get('poliamida_dw'),
      poliester_dw: get('poliester_dw'),
      acrilico_dw: get('acrilico_dw'),
      lana_dw: get('lana_dw'),
      cambio_color_dw: get('cambio_color_dw'),
      diacetato_tv: get('diacetato_tv'),
      algodon_blanqueado_tv: get('algodon_tv'),
      poliamida_tv: get('poliamida_tv'),
      poliester_tv: get('poliester_tv'),
      acrilico_tv: get('acrilico_tv'),
      viscosa_tv: get('lana_tv'),
      cambio_color_tv: get('cambio_color_tv'),
      diacetato_dw_label: get('diacetato_dw_label'),
      diacetato_tv_label: get('diacetato_tv_label'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-105-E04-INNTEX-2019 SOLIDEZ DEL COLOR AL SUDOR')) {
    return {
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      posicionEspecimenes: get('pos_especimenes'),
      TIPO_MULTIFIBRA: get('tipo_multifibra'),
      FORMA_EVALUACION: get('forma_evaluacion'),
      METODO_C: get('metodo_c'),
      diacetato_acido: get('diacetato_ac'),
      algodon_blanqueado_acido: get('algodon_ac'),
      poliamida_acido: get('poliamida_ac'),
      poliester_acido: get('poliester_ac'),
      acrilico_acido: get('acrilico_ac'),
      lana_acido: get('lana_ac'),
      cambio_color_acido: get('cambio_color_ac'),
      diacetato_alcalino: get('diacetato_al'),
      algodon_blanqueado_alcalino: get('algodon_al'),
      poliamida_alcalino: get('poliamida_al'),
      poliester_alcalino: get('poliester_al'),
      acrilico_alcalino: get('acrilico_al'),
      lana_alcalino: get('lana_al'),
      cambio_color_alcalino: get('cambio_color_al'),
      promedio1: get('promedio1'),
      promedio2: get('promedio2'),
      resultado1: get('resultado1'),
      resultado2: get('resultado2'),
      diacetato_acido_label: get('diacetato_acido_label'),
      diacetato_alcalino_label: get('diacetato_alcalino_label'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('TIPO DE ACABADO MET-7.2-19')) {
    return {
      fecha: get('fecha'),
      numero_solicitud: get('numero_solicitud'),
      resultado: get('resultado'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-5077-INNTEX-2015 / NMX-A-6330-INNTEX-2015 CAMBIOS DIMENSIONALES')) {
    return {
      fecha: get('fecha'),
      hora: get('hora'),
      grados: get('grados'),
      hr: get('hr'),
      numero_solicitud: get('numero_solicitud'),
      id_termohigrometro: get('termo'),
      tipo_de_carga: get('tipo_carga'),
      ciclos: get('ciclos'),
      lavado: get('lavado'),
      secado: get('secado'),
      tipo_de_lavadora: get('tipo_lavadora'),
      tipo_lavado_ora: get('tipo_lavadora'),
      tipo_de_secado_ora: get('tipo_secadora'),
      DIM_ESPECIM: get('dim_especim'),
      m1_urd_inicial_1: get('m1_uc_mi1'),
      m1_urd_inicial_2: get('m1_uc_mi2'),
      m1_urd_inicial_3: get('m1_uc_mi3'),
      m1_urd_inicial_prom: get('m1_uc_mipro'),
      m1_urd_final_1: get('m1_uc_mf1'),
      m1_urd_final_2: get('m1_uc_mf2'),
      m1_urd_final_3: get('m1_uc_mf3'),
      m1_urd_final_prom: get('m1_uc_mfpro'),
      m1_urd_cambio: get('m1_uc_cambio'),
      m1_tra_inicial_1: get('m1_tm_mi1'),
      m1_tra_inicial_2: get('m1_tm_mi2'),
      m1_tra_inicial_3: get('m1_tm_mi3'),
      m1_tra_inicial_prom: get('m1_tm_mipro'),
      m1_tra_final_1: get('m1_tm_mf1'),
      m1_tra_final_2: get('m1_tm_mf2'),
      m1_tra_final_3: get('m1_tm_mf3'),
      m1_tra_final_prom: get('m1_tm_mfpro'),
      m1_tra_cambio: get('m1_tm_cambio'),
      m2_urd_inicial_1: get('m2_uc_mi1'),
      m2_urd_inicial_2: get('m2_uc_mi2'),
      m2_urd_inicial_3: get('m2_uc_mi3'),
      m2_urd_inicial_prom: get('m2_uc_mipro'),
      m2_urd_final_1: get('m2_uc_mf1'),
      m2_urd_final_2: get('m2_uc_mf2'),
      m2_urd_final_3: get('m2_uc_mf3'),
      m2_urd_final_prom: get('m2_uc_mfpro'),
      m2_urd_cambio: get('m2_uc_cambio'),
      m2_tra_inicial_1: get('m2_tm_mi1'),
      m2_tra_inicial_2: get('m2_tm_mi2'),
      m2_tra_inicial_3: get('m2_tm_mi3'),
      m2_tra_inicial_prom: get('m2_tm_mipro'),
      m2_tra_final_1: get('m2_tm_mf1'),
      m2_tra_final_2: get('m2_tm_mf2'),
      m2_tra_final_3: get('m2_tm_mf3'),
      m2_tra_final_prom: get('m2_tm_mfpro'),
      m2_tra_cambio: get('m2_tm_cambio'),
      promedio_urdimbre: get('promedio_uc'),
      redondeo_urdimbre: get('redondeo_uc'),
      promedio_trama: get('promedio_tm'),
      redondeo_trama: get('redondeo_tm'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('ANÁLISIS QUÍMICO CUALITATIVO Y CUANTITATIVO')) {
    return {
      numeroSolicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      normaSeleccionada: get('opcion_nmx'),
      OPCION_NMX: get('opcion_nmx'),
      opciones: get('opciones'),
      pretratamiento: get('pretratamiento') === 'Si' ? 'con_pretratamiento' : get('pretratamiento') === 'No' ? 'sin_pretratamiento' : get('pretratamiento'),
      resultadoQuimico: get('resultado_quimico'),
      realizo: get('realizo'),
      superviso: get('superviso'),
      observaciones: get('observaciones'),
      sustancia: get('sustancia'),
      reportarApresto: get('reportar_apresto'),
      p0: get('p0'),
      pf: get('pf'),
      fibra: get('fibra'),
      m0: get('m0'),
      m1: get('m1'),
      d: get('d'),
      fibra_ro: get('fibra_ro'),
      fibra_cs: get('fibra_cs'),
      combustion: get('combustion'),
      microscopia: get('microscopia'),
      analisis_quimico: get('analisis_quimico'),
      ACEPTADO: get('aceptado'),
      RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-105-D01-INNTEX-2020')) {
    return {
      numero_solicitud: get('numero_solicitud'),
      fecha: get('fecha'),
      solvente: get('solvente'),
      multifibra: get('multifibra'),
      diacetato_dw: get('diacetato_dw'), algodon_dw: get('algodon_dw'),
      poliamida_dw: get('poliamida_dw'), poliester_dw: get('poliester_dw'),
      acrilico_dw: get('acrilico_dw'), lana_dw: get('lana_dw'),
      cambio_color_dw: get('cambio_color_dw'),
      triacetato_tv: get('triacetato_tv'), algodon_tv: get('algodon_tv'),
      poliamida_tv: get('poliamida_tv'), poliester_tv: get('poliester_tv'),
      acrilico_tv: get('acrilico_tv'), viscosa_tv: get('viscosa_tv'),
      cambio_color_tv: get('cambio_color_tv'),
      observaciones: get('observaciones'), desv_metodo: get('desv_metodo'),
      realizo: get('realizo'), autorizo: get('autorizo'),
      ACEPTADO: get('aceptado'), RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-105-B02-INNTEX-2019')) {
    return {
      numero_solicitud: get('numero_solicitud'), fecha: get('fecha'),
      ciclo_exposicion: get('ciclo_exposicion'),
      temp_estandar_negro: get('temp_estandar_negro'),
      temp_panel_negro: get('temp_panel_negro'),
      humedad_relativa: get('humedad_relativa'),
      irradiacion: get('irradiacion'), longitud_onda: get('longitud_onda'),
      tiempo_exposicion: get('tiempo_exposicion'),
      exposicion_radiante: get('exposicion_radiante'),
      grado_escala_gris: get('grado_escala_gris'),
      observaciones: get('observaciones'), desv_metodo: get('desv_metodo'),
      realizo: get('realizo'), autorizo: get('autorizo'),
      ACEPTADO: get('aceptado'), RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-A-059/1-INNTEX-2019')) {
    const d: any = {
      numero_solicitud: get('numero_solicitud'),
      fecha: get('fecha'), hora: get('hora'),
      temperatura: get('temperatura'), hr: get('hr'),
      id_termohigrometro: get('id_termohigrometro'),
      longitud_ensayo: get('longitud_ensayo'),
      velocidad_alargamiento: get('velocidad_alargamiento'),
      ancho_tira: get('ancho_tira'),
      estado_especimenes: get('estado_especimenes'),
      num_especimenes: get('num_especimenes'),
      especimenes_rechazados: get('especimenes_rechazados'),
      num_hilos_tira: get('num_hilos_tira'),
      tablas_activas: get('tablas_activas'),
      reportar: String(get('reportar')) !== 'false',
      tiene_metodo_muestreo: String(get('tiene_metodo_muestreo')) === 'true',
      metodo_muestreo: get('metodo_muestreo') || '',
      observaciones: get('observaciones'), desv_metodo: get('desv_metodo'),
      realizo: get('realizo'), superviso: get('superviso'),
      ACEPTADO: get('aceptado'), RAZON_RECHAZO: get('razon_rechazo'),
    }
    for (const t of ['fm','fr','afm','ar']) {
      for (let i = 1; i <= 5; i++) {
        d[`${t}_u${i}`] = get(`${t}_u${i}`)
        d[`${t}_t${i}`] = get(`${t}_t${i}`)
      }
      d[`${t}_prom_u`] = get(`${t}_prom_u`)
      d[`${t}_prom_t`] = get(`${t}_prom_t`)
      d[`${t}_red_u`] = get(`${t}_red_u`)
      d[`${t}_red_t`] = get(`${t}_red_t`)
    }
    return d
  }

  if (prueba.includes('NMX-A-059/2-INNTEX-2019') || prueba.includes('059/2') || prueba.includes('Grab')) {
    return {
      numero_solicitud: get('numero_solicitud'),
      fecha: get('fecha'), hora: get('hora'),
      temperatura: get('temperatura'), hr: get('hr'),
      id_termohigrometro: get('id_termohigrometro'),
      especimenes_u: get('especimenes_u'), especimenes_t: get('especimenes_t'),
      longitud_ensayo: get('longitud_ensayo'),
      especimenes_rechazados: get('especimenes_rechazados'),
      estado_especimenes: get('estado_especimenes'),
      no1_u: get('no1_u'), no2_u: get('no2_u'), no3_u: get('no3_u'), no4_u: get('no4_u'), no5_u: get('no5_u'),
      no1_t: get('no1_t'), no2_t: get('no2_t'), no3_t: get('no3_t'), no4_t: get('no4_t'), no5_t: get('no5_t'),
      promedio_u: get('promedio_u'), redondeo_u: get('redondeo_u'),
      promedio_t: get('promedio_t'), redondeo_t: get('redondeo_t'),
      reportar: String(get('reportar')) !== 'false',
      tiene_metodo_muestreo: String(get('tiene_metodo_muestreo')) === 'true',
      metodo_muestreo: get('metodo_muestreo') || '',
      observaciones: get('observaciones'), desv_metodo: get('desv_metodo'),
      realizo: get('realizo'), superviso: get('superviso'),
      ACEPTADO: get('aceptado'), RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('AATCC TM127-2017')) {
    return {
      numero_solicitud: get('numero_solicitud'),
      fecha: get('fecha'), hora: get('hora'),
      temperatura: get('temperatura'), hr: get('hr'),
      id_termohigrometro: get('id_termohigrometro'),
      tipo_material: get('tipo_material'), tipo_agua: get('tipo_agua'),
      temp_agua: get('temp_agua'), cara_delantera: get('cara_delantera'),
      no1: get('no1'), no2: get('no2'), no3: get('no3'), promedio: get('promedio'),
      observaciones: get('observaciones'), desv_metodo: get('desv_metodo'),
      realizo: get('realizo'), superviso: get('superviso'),
      ACEPTADO: get('aceptado'), RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('PRUEBA ADICIONAL')) {
    return {
      nombre_prueba: get('nombre_prueba'),
      fecha: get('fecha'),
      nota_doc: get('nota_doc'),
      observaciones: get('observaciones'),
      realizo: get('realizo'), superviso: get('superviso'),
      ACEPTADO: get('aceptado'), RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  if (prueba.includes('NMX-S-051-1989')) {
    return {
      numero_solicitud: get('numero_solicitud'), fecha: get('fecha'),
      inicio_hora: get('inicio_hora'), inicio_temp: get('inicio_temp'),
      inicio_hr: get('inicio_hr'), inicio_termo: get('inicio_termo'),
      fin_hora: get('fin_hora'), fin_temp: get('fin_temp'),
      fin_hr: get('fin_hr'), fin_termo: get('fin_termo'),
      flexiones_programadas: get('flexiones_programadas'),
      tipo_agua: get('tipo_agua'), tiempo_inmersion: get('tiempo_inmersion'),
      seco_100_con: get('seco_100_con'), seco_100_sin: get('seco_100_sin'),
      seco_1000_con: get('seco_1000_con'), seco_1000_sin: get('seco_1000_sin'),
      seco_10000_con: get('seco_10000_con'), seco_10000_sin: get('seco_10000_sin'),
      seco_20000_con: get('seco_20000_con'), seco_20000_sin: get('seco_20000_sin'),
      seco_48000_con: get('seco_48000_con'), seco_48000_sin: get('seco_48000_sin'),
      hum_100_con: get('hum_100_con'), hum_100_sin: get('hum_100_sin'),
      hum_1000_con: get('hum_1000_con'), hum_1000_sin: get('hum_1000_sin'),
      hum_10000_con: get('hum_10000_con'), hum_10000_sin: get('hum_10000_sin'),
      hum_18000_con: get('hum_18000_con'), hum_18000_sin: get('hum_18000_sin'),
      flex_prom_seco: get('flex_prom_seco'), flex_prom_hum: get('flex_prom_hum'),
      dano_seco: get('dano_seco'), dano_hum: get('dano_hum'),
      observaciones: get('observaciones'), desv_metodo: get('desv_metodo'),
      realizo: get('realizo'), autorizo: get('autorizo'),
      ACEPTADO: get('aceptado'), RAZON_RECHAZO: get('razon_rechazo'),
    }
  }

  // Default: return row as-is with normalized ACEPTADO
  return {
    ...row,
    ACEPTADO: get('aceptado'),
    RAZON_RECHAZO: get('razon_rechazo'),
  }
}

/**
 * INSERT a new prueba record and return the new row id.
 */
/**
 * Saves a prueba record and ensures a noms record links it to the pedido.
 *
 * - If nomId is provided: updates the existing noms row (row_id_prueba → new id).
 * - If nomId is NOT provided (pre-loaded prueba from articulos): creates a new noms row.
 *
 * Returns { pruebaId, nomId } so the caller can update local state.
 */
export async function guardarPrueba(
  prueba: string,
  pedidoId: string,
  formData: any,
  nomId?: string,
  existingRowId?: string,
  esBorrador?: boolean,
): Promise<{ pruebaId: number; nomId: string }> {
  const tabla = getTable(prueba)
  const data = formDataToSupabase(prueba, formData, pedidoId)

  let pruebaId: number

  if (existingRowId) {
    const { data: result, error } = await supabase
      .from(tabla)
      .update(data)
      .eq('id', Number(existingRowId))
      .select('id')
      .single()
    if (error) throw new Error(error.message)
    pruebaId = result.id
  } else {
    const { data: result, error } = await supabase
      .from(tabla)
      .insert(data)
      .select('id')
      .single()
    if (error) throw new Error(error.message)
    pruebaId = result.id
  }

  // El toggle "mostrar observaciones en Reporte Cliente" vive en noms (no en la
  // tabla prueba_XXXX), lo trae cada formulario en formData.mostrarObservaciones.
  const mostrarObservaciones = formData?.mostrarObservaciones === true

  if (nomId) {
    // esBorrador !== undefined: viene de un guardado que sabe explícitamente si es
    // borrador (autosave) o guardado oficial (limpia la marca). Si no se especifica,
    // no se toca `estado` (comportamiento de los formularios que aún no usan autosave).
    const updates: Record<string, any> = { row_id_prueba: pruebaId, mostrar_observaciones: mostrarObservaciones }
    if (esBorrador !== undefined) {
      if (esBorrador) {
        // Un autosave puede quedar en vuelo (o ya encolado por el debounce) cuando el
        // usuario presiona Aceptar/Rechazar. Si ese autosave se resuelve después,
        // pisaría el `estado: null` que actualizarAceptado() ya dejó, y la prueba
        // volvería a verse como BORRADOR (con botón CONTINUAR) aunque ya esté
        // ACEPTADO/RECHAZADO. Por eso solo marcamos 'borrador' si la prueba sigue
        // sin aceptar/rechazar al momento de escribir.
        const { data: nomActual } = await supabase
          .from('noms')
          .select('aceptado')
          .eq('id', nomId)
          .single()
        if (!nomActual?.aceptado) updates.estado = 'borrador'
      } else {
        updates.estado = null
      }
    }
    const { error: nomErr } = await supabase
      .from('noms')
      .update(updates)
      .eq('id', nomId)
    if (nomErr) throw new Error(nomErr.message)
    return { pruebaId, nomId }
  } else {
    // No noms record yet (prueba was pre-loaded from articulos) — create one
    const tipoPrueba = TABLE_TO_TIPO[tabla]
    if (!tipoPrueba) throw new Error(`Tipo de prueba no encontrado para tabla: ${tabla}`)

    const { data: newNom, error: nomErr } = await supabase
      .from('noms')
      .insert({
        pedido_id: pedidoId,
        tipo_prueba: tipoPrueba,
        row_id_prueba: pruebaId,
        aceptado: '',
        estado: esBorrador ? 'borrador' : null,
        mostrar_observaciones: mostrarObservaciones,
      })
      .select('id')
      .single()
    if (nomErr) throw new Error(nomErr.message)
    return { pruebaId, nomId: newNom.id }
  }
}

/**
 * SELECT a prueba row by id from the correct table.
 */
export async function revisarPrueba(prueba: string, rowId: string): Promise<any> {
  const tabla = getTable(prueba)

  const { data, error } = await supabase
    .from(tabla)
    .select('*')
    .eq('id', parseInt(rowId, 10))
    .single()

  if (error) throw new Error(error.message)
  return data
}

/**
 * UPDATE a nom record by its UUID.
 */
export async function actualizarNom(nomId: string, updates: {
  row_id_prueba?: string
  aceptado?: string
  razon_rechazo?: string
}): Promise<void> {
  const { error } = await supabase
    .from('noms')
    .update(updates)
    .eq('id', nomId)

  if (error) throw new Error(error.message)
}

/**
 * Controla si una prueba se incluye en el Reporte Cliente (la Bitácora siempre
 * incluye todas las pruebas, sin importar este valor).
 */
export async function actualizarIncluirReporteCliente(nomId: string, incluir: boolean): Promise<void> {
  const { error } = await supabase
    .from('noms')
    .update({ incluir_reporte_cliente: incluir })
    .eq('id', nomId)

  if (error) throw new Error(error.message)
}

export async function obtenerNotaDocCliente(pedidoId: string): Promise<string | null> {
  const { data, error } = await supabase
    .from('pedidos')
    .select('nota_doc_cliente')
    .eq('id', pedidoId)
    .single()

  if (error) throw new Error(error.message)
  return data?.nota_doc_cliente || null
}

export async function actualizarNotaDocCliente(pedidoId: string, notaDoc: string | null): Promise<void> {
  const { error } = await supabase
    .from('pedidos')
    .update({ nota_doc_cliente: notaDoc })
    .eq('id', pedidoId)

  if (error) throw new Error(error.message)
}

export async function actualizarFechasPedido(
  pedidoId: string,
  fechas: { fechaEmision?: string; fechaEntrega?: string; createdAt?: string }
): Promise<void> {
  const data: Record<string, string> = {}
  if (fechas.fechaEmision) data.fecha_emision = fechas.fechaEmision
  if (fechas.fechaEntrega) data.fecha_entrega = fechas.fechaEntrega
  if (fechas.createdAt) data.created_at = fechas.createdAt

  const { error } = await supabase
    .from('pedidos')
    .update(data)
    .eq('id', pedidoId)

  if (error) throw new Error(error.message)
}

/**
 * Persiste el orden manual (drag and drop) de las pruebas de un pedido.
 * Este orden controla tanto la lista de PRUEBAS SOLICITADAS como el orden
 * en que aparecen las secciones en el Reporte Cliente y la Bitácora.
 */
export async function actualizarOrdenPruebas(actualizaciones: Array<{ nomId: string; orden: number }>): Promise<void> {
  const resultados = await Promise.all(
    actualizaciones.map(({ nomId, orden }) =>
      supabase.from('noms').update({ orden }).eq('id', nomId)
    )
  )
  const conError = resultados.find(r => r.error)
  if (conError?.error) throw new Error(conError.error.message)
}

/**
 * Accept or reject a prueba by its row_id_prueba (integer ID in the prueba_XXXX table).
 * Optionally also sets supervisado_por in noms and superviso in the prueba_* table.
 *
 * @param pruebaRowId   - Integer ID of the row in the prueba_XXXX table
 * @param aceptado      - 'aceptado' | 'rechazado'
 * @param razonRechazo  - Required when aceptado = 'rechazado'
 * @param supervisadoPor - Optional name of the supervisor
 */
export async function actualizarAceptado(
  pruebaRowId: number | string,
  aceptado: 'aceptado' | 'rechazado',
  razonRechazo?: string,
  supervisadoPor?: string,
  nomId?: string | number,
): Promise<void> {
  // nomId (noms.id, un uuid único) es la única forma segura de identificar la fila a actualizar.
  // row_id_prueba es solo el PK dentro de la tabla prueba_XXXX correspondiente, y NO es único
  // entre distintos tipos de prueba — dos pruebas distintas del mismo pedido pueden compartir el
  // mismo row_id_prueba. Sin nomId no hay forma segura de aplicar el cambio: se aborta en vez de
  // arriesgar actualizar por accidente otra prueba con el mismo row_id_prueba.
  if (!nomId) {
    throw new Error('No se pudo identificar la prueba de forma única (falta nomId); no se realizó ningún cambio.')
  }

  // Supervisor: explicit arg takes priority, then localStorage fallback
  const supervisor = supervisadoPor || (typeof window !== 'undefined' ? localStorage.getItem('userName') || '' : '')

  // SELECT tipo_prueba BEFORE the update (avoids RLS SELECT-after-update issues).
  // También traemos row_id_prueba aquí (en vez de confiar en el parámetro pruebaRowId que
  // manda el caller) para que el update de abajo a la tabla prueba_XXXX quede completamente
  // atado al nomId ya verificado, y no pueda desincronizarse si el caller nos pasa un rowId
  // que no corresponde a este mismo nomId.
  const { data: nomInfo } = await supabase
    .from('noms')
    .select('id, tipo_prueba, row_id_prueba')
    .eq('id', String(nomId))
    .single()

  // Al aceptar/rechazar la prueba ya deja de ser un borrador: si quedó marcada
  // 'borrador' por un autosave previo (o por un guardado oficial que no limpió
  // el campo), el botón en PedidosView seguía mostrando CONTINUAR en vez de
  // REVISAR aun con la prueba ya aceptada. Limpiar `estado` aquí asegura que
  // el estado de borrador nunca sobreviva a una aceptación/rechazo.
  const nomUpdates: Record<string, any> = { aceptado, estado: null }
  if (razonRechazo) nomUpdates.razon_rechazo = razonRechazo
  if (supervisor) nomUpdates.supervisado_por = supervisor

  const { error } = await supabase
    .from('noms')
    .update(nomUpdates)
    .eq('id', String(nomId))

  if (error) throw new Error(error.message)

  // Also update superviso/autorizo in the prueba_* table
  // Some tables use 'autorizo' as the supervisor column instead of 'superviso'
  const AUTORIZO_TABLES = new Set(['prueba_105d01', 'prueba_105b02', 'prueba_s051'])
  const tabla = nomInfo?.tipo_prueba
    ? Object.entries(TABLE_TO_TIPO).find(([, tipo]) => tipo === nomInfo.tipo_prueba)?.[0]
    : undefined
  if (supervisor && tabla && nomInfo?.row_id_prueba) {
    const supervisoField = AUTORIZO_TABLES.has(tabla) ? 'autorizo' : 'superviso'
    await supabase
      .from(tabla)
      .update({ [supervisoField]: supervisor })
      .eq('id', Number(nomInfo.row_id_prueba))
    // Best-effort — errors ignored silently
  }

  // Audit trail: quién/cuándo/desde qué prueba se aceptó o rechazó (best-effort, no bloquea la acción)
  if (nomInfo?.id) {
    try {
      await supabase.from('aceptacion_historial').insert({
        nom_id: nomInfo.id,
        prueba_tabla: tabla || nomInfo.tipo_prueba || '',
        row_id: Number(nomInfo.row_id_prueba ?? pruebaRowId),
        accion: aceptado,
        razon_rechazo: razonRechazo || null,
        realizado_por: supervisor || null,
      })
    } catch (auditErr) {
      console.warn('No se pudo registrar el historial de aceptación:', auditErr)
    }
  }
}

/**
 * Register an edit to a prueba for audit trail.
 * Inserts into prueba_ediciones and marks noms as edited.
 */
export async function registrarEdicion(
  nomId: string,
  prueba: string,
  rowId: number | string,
  datosAntes: any,
  datosDespues: any,
  editadoPor: string,
  silencioso = false,
): Promise<void> {
  if (silencioso) return

  const tabla = getTable(prueba)

  const { error: edicionErr } = await supabase
    .from('prueba_ediciones')
    .insert({
      nom_id: nomId,
      prueba_tabla: tabla,
      row_id: Number(rowId),
      datos_antes: datosAntes,
      datos_despues: datosDespues,
      editado_por: editadoPor,
    })

  if (edicionErr) throw new Error(edicionErr.message)

  const { error: nomErr } = await supabase
    .from('noms')
    .update({
      editado: true,
      editado_por: editadoPor,
      editado_at: new Date().toISOString(),
    })
    .eq('id', nomId)

  if (nomErr) throw new Error(nomErr.message)
}

/**
 * Create a new user in the usuarios table.
 * The user can log in once they register in Supabase Auth with the same email.
 */
export async function crearUsuario(data: {
  nombre: string;
  correo: string;
  puesto: string;
  area?: string;
}): Promise<void> {
  const { error } = await supabase
    .from('usuarios')
    .insert(data)

  if (error) throw new Error(error.message)
}

/**
 * Update an existing user in the usuarios table.
 * Uses .select() so that an update blocked by RLS (0 rows affected) surfaces
 * as an explicit error instead of silently doing nothing.
 */
export async function actualizarUsuario(id: string, data: {
  nombre?: string;
  puesto?: string;
  area?: string;
  autoriza_reapertura?: boolean;
}): Promise<void> {
  const { data: updated, error } = await supabase
    .from('usuarios')
    .update(data)
    .eq('id', id)
    .select('id')

  if (error) throw new Error(error.message)
  if (!updated || updated.length === 0) {
    throw new Error('No se pudo actualizar el usuario (sin permisos o el usuario ya no existe).')
  }
}

/**
 * Delete a user from the usuarios table. This only revokes their access to
 * this system (is_usuario_registrado() will stop matching their email); it
 * does not delete their Supabase Auth account.
 */
export async function eliminarUsuario(id: string): Promise<void> {
  const { data: deleted, error } = await supabase
    .from('usuarios')
    .delete()
    .eq('id', id)
    .select('id')

  if (error) throw new Error(error.message)
  if (!deleted || deleted.length === 0) {
    throw new Error('No se pudo eliminar el usuario (sin permisos o ya no existe).')
  }
}

/**
 * Fetch the role x action permission matrix (permisos_rol) for all roles.
 */
export async function obtenerPermisos(): Promise<{ rol_id: string; accion: string; permitido: boolean }[]> {
  const { data, error } = await supabase
    .from('permisos_rol')
    .select('rol_id, accion, permitido')

  if (error) throw new Error(error.message)
  return data || []
}

/**
 * Toggle a single permission cell in the matrix. Only ADMIN can write (enforced by RLS).
 */
export async function actualizarPermiso(rolId: string, accion: string, permitido: boolean): Promise<void> {
  const { error } = await supabase
    .from('permisos_rol')
    .upsert({ rol_id: rolId, accion, permitido }, { onConflict: 'rol_id,accion' })

  if (error) throw new Error(error.message)
}

/**
 * Create a new client in the clientes table.
 */
export async function crearCliente(data: {
  nombre: string;
  clave_cliente?: string;
  contacto?: string;
  correo?: string;
  telefono?: string;
  direccion?: string;
}): Promise<void> {
  const { error } = await supabase
    .from('clientes')
    .insert(data)

  if (error) throw new Error(error.message)
}

/**
 * Update an existing client in the clientes table.
 */
export async function actualizarCliente(id: string, data: {
  nombre?: string;
  clave_cliente?: string;
  contacto?: string;
  correo?: string;
  telefono?: string;
  direccion?: string;
}): Promise<void> {
  const { error } = await supabase
    .from('clientes')
    .update(data)
    .eq('id', id)

  if (error) throw new Error(error.message)
}

/**
 * Sobrescribe los datos de contacto del cliente (nombre, teléfono, correo y
 * dirección) guardados dentro de uno o más pedidos con los valores actuales
 * de su ficha en `clientes`. No afecta reportes ya generados: hay que
 * reabrir y regenerar el reporte para ver el cambio reflejado ahí.
 */
export async function actualizarDatosClienteEnPedidos(pedidoIds: string[], data: {
  nombre_cliente?: string;
  telefono?: string;
  correo?: string;
  direccion?: string;
}): Promise<void> {
  if (pedidoIds.length === 0) return
  const { error } = await supabase
    .from('pedidos')
    .update(data)
    .in('id', pedidoIds)

  if (error) throw new Error(error.message)
}

/**
 * Reabrir un pedido cerrado, Caso A (con trazabilidad): crea un pedido nuevo
 * completo por medio de la función RPC ejecutar_reapertura_con_trazabilidad,
 * que clona todas las pruebas del original en una sola transacción atómica.
 * El pedido original nunca se modifica.
 */
export async function crearReaperturaConTrazabilidad(params: {
  pedidoId: string;
  origenNumeroNuevo: string;
  fechaEmision: string;
  fechaEntrega: string;
  evidenciaUrl: string;
  solicitadoPor: string;
}): Promise<{ nuevoPedidoId: string }> {
  const { data, error } = await supabase.rpc('ejecutar_reapertura_con_trazabilidad', {
    p_pedido_id: params.pedidoId,
    p_origen_numero_nuevo: params.origenNumeroNuevo,
    p_fecha_emision: params.fechaEmision,
    p_fecha_entrega: params.fechaEntrega,
    p_evidencia_url: params.evidenciaUrl,
    p_solicitado_por: params.solicitadoPor,
  })

  if (error) throw new Error(error.message)
  return { nuevoPedidoId: data as string }
}

/**
 * Si este pedido fue creado por una reapertura con trazabilidad (Caso A),
 * regresa el registro con la evidencia subida y el pedido original del que
 * proviene. Se usa para mostrar el link "Ver evidencia" en PedidoDetail.
 */
export async function obtenerReaperturaOrigen(pedidoId: string): Promise<{
  evidenciaUrl: string | null;
  solicitadoPor: string;
  createdAt: string;
  origenNumeroAnterior: string | null;
} | null> {
  const { data, error } = await supabase
    .from('reaperturas')
    .select('evidencia_url, solicitado_por, created_at, pedidos!reaperturas_pedido_id_fkey(origen_numero)')
    .eq('pedido_nuevo_id', pedidoId)
    .eq('tipo', 'con_trazabilidad')
    .maybeSingle()

  if (error) throw new Error(error.message)
  if (!data) return null

  return {
    evidenciaUrl: data.evidencia_url,
    solicitadoPor: data.solicitado_por,
    createdAt: data.created_at,
    origenNumeroAnterior: (data as any).pedidos?.origen_numero ?? null,
  }
}

/**
 * Reabrir un pedido cerrado, Caso B (sin trazabilidad): deja la solicitud en
 * estado 'pendiente' hasta que alguien con autoriza_reapertura=true la
 * apruebe. No modifica el pedido todavía.
 */
export async function crearSolicitudReaperturaSinTrazabilidad(params: {
  pedidoId: string;
  fechaEmisionNueva: string;
  fechaEntregaNueva: string;
  solicitadoPor: string;
}): Promise<void> {
  const { error } = await supabase.from('reaperturas').insert({
    pedido_id: params.pedidoId,
    tipo: 'sin_trazabilidad',
    estado: 'pendiente',
    solicitado_por: params.solicitadoPor,
    fecha_emision_nueva: params.fechaEmisionNueva,
    fecha_entrega_nueva: params.fechaEntregaNueva,
  })

  if (error) {
    // Violación del índice único reaperturas_un_pendiente_por_pedido: ya hay
    // una solicitud pendiente para este pedido.
    if (error.code === '23505') {
      throw new Error('Ya hay una solicitud de reapertura pendiente de autorización para este pedido.')
    }
    throw new Error(error.message)
  }
}

/**
 * Fetch pending Caso B (sin trazabilidad) reopen requests, for the panel
 * shown to users with autoriza_reapertura=true.
 */
export async function obtenerReaperturasPendientes(): Promise<Array<{
  id: string;
  pedido_id: string;
  solicitado_por: string;
  fecha_emision_nueva: string;
  fecha_entrega_nueva: string;
  created_at: string;
  pedidos: { origen_numero: string | null; nombre_cliente: string | null } | null;
}>> {
  // `reaperturas` tiene dos FKs hacia `pedidos` (pedido_id y pedido_nuevo_id),
  // así que el embed necesita el hint del nombre de la FK: sin él, PostgREST
  // no puede decidir cuál relación usar y responde con un error de embed
  // ambiguo (PGRST201) que aquí se traduciría en una lista vacía silenciosa.
  const { data, error } = await supabase
    .from('reaperturas')
    .select('id, pedido_id, solicitado_por, fecha_emision_nueva, fecha_entrega_nueva, created_at, pedidos!reaperturas_pedido_id_fkey(origen_numero, nombre_cliente)')
    .eq('estado', 'pendiente')
    .order('created_at', { ascending: true })

  if (error) throw new Error(error.message)
  return (data as any) || []
}

/**
 * Approve a pending Caso B request — runs the atomic RPC that wipes reports
 * and edit history and puts the pedido back in draft state, then deletes the
 * actual PDF files from Storage (the RPC only nulls the DB pointers, since
 * plpgsql can't call the Storage API).
 */
export async function aprobarReaperturaSinTrazabilidad(reaperturaId: string, autorizadoPor: string): Promise<void> {
  // Capturar las URLs de los informes ANTES de aprobar: el RPC limpia
  // cliente_link/bitacora_link en `pedidos`, así que hay que guardarlas
  // primero para poder borrar los archivos del bucket después.
  const { data: reapertura, error: fetchError } = await supabase
    .from('reaperturas')
    .select('pedidos!reaperturas_pedido_id_fkey(cliente_link, bitacora_link)')
    .eq('id', reaperturaId)
    .single()
  if (fetchError) throw new Error(fetchError.message)

  const { error } = await supabase.rpc('aprobar_reapertura_sin_trazabilidad', {
    p_reapertura_id: reaperturaId,
    p_autorizado_por: autorizadoPor,
  })
  if (error) throw new Error(error.message)

  const pedido = (reapertura as any)?.pedidos
  if (pedido) {
    await borrarInformesStorage([pedido.cliente_link, pedido.bitacora_link])
  }
}

/**
 * Reject a pending Caso B request — the pedido is left completely untouched.
 */
export async function rechazarReaperturaSinTrazabilidad(reaperturaId: string): Promise<void> {
  const { error } = await supabase
    .from('reaperturas')
    .update({ estado: 'rechazado', resuelto_at: new Date().toISOString() })
    .eq('id', reaperturaId)

  if (error) throw new Error(error.message)
}

/**
 * Fetch edit history for a prueba by its row_id (integer ID in prueba_* table).
 */
export async function obtenerHistorialEdicion(nomId: string): Promise<Array<{
  id: string;
  prueba_tabla: string;
  row_id: number;
  datos_antes: Record<string, any>;
  datos_despues: Record<string, any>;
  editado_por: string;
  created_at: string;
}>> {
  const { data, error } = await supabase
    .from('prueba_ediciones')
    .select('id, prueba_tabla, row_id, datos_antes, datos_despues, editado_por, created_at')
    .eq('nom_id', nomId)
    .order('created_at', { ascending: false })

  if (error) throw new Error(error.message)
  return data || []
}
